import { render, staticRenderFns } from "./disclo.vue?vue&type=template&id=3d732568&scoped=true"
import script from "./disclo.vue?vue&type=script&lang=js"
export * from "./disclo.vue?vue&type=script&lang=js"
import style0 from "./disclo.vue?vue&type=style&index=0&id=3d732568&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d732568",
  null
  
)

export default component.exports